@if (show()) {
  <div
    #backTopBtn
    (click)="goTop()"
    inlineSVG="goToTop/arrow-up.svg"
    class="goTopButton"
  ></div>
}
